export function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/date-picker/utils.js
// module id = 377
// module chunks = 14